function translate(id, i18n, lang) {
  const term = i18n[id]
  return !term ? id: term[lang] || term['en'] || id
}

export { translate }


// WEBPACK FOOTER //
// ./src/translate.js